module.exports = __webpack_public_path__ + "static/media/rou_under_high.e8ecce36.png";